export default __webpack_public_path__ + "static/media/valoracion.a3c17ee9.svg";